import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { ThemeProvider } from '@mygpt/app/theme';

// remove end slash from basename // @ts-ignore
const basename = import.meta.env.VITE_PUBLIC_PATH === '/' ? '/' : import.meta.env.VITE_PUBLIC_PATH.replace(/\/$/, '');

export default ({ children }: PropsWithChildren) => {
  return (
    <BrowserRouter basename={basename}>
      <ThemeProvider>
        <Notifications position="top-center" limit={3} />
        <ModalsProvider>{children}</ModalsProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};
